import { Dialog } from '@cw-ui/feedback-components';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';
import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { useDeleteUserRowMutation } from '../../services/bulkUserImportService';
import {
    setRemoveUserDialogOpen,
    setRemoveUserFailedAlert,
    setRemoveUserSuccessAlert,
    bulkImportUsersSliceId,
    setIsRemoveUserLoading,
} from '../../slice';
import * as Styled from './RemoveUserDialog.styled';

const RemoveUserDialog = () => {
    const dispatch = useDispatch();
    const [deleteUserRow] = useDeleteUserRowMutation();
    const selectedUserIdToDelete = useSelector(state => state[bulkImportUsersSliceId]?.selectedUserIdToDelete);

    const handleClose = () => {
        dispatch(setRemoveUserDialogOpen());
    };

    const handleRemoveUser = async () => {
        handleClose();
        try {
            dispatch(setIsRemoveUserLoading(true));
            await deleteUserRow({ id: selectedUserIdToDelete }).unwrap();
            dispatch(setRemoveUserSuccessAlert());
        } catch (error) {
            console.error('Error deleting user row:', error);
            dispatch(setRemoveUserFailedAlert());
        } finally {
            dispatch(setIsRemoveUserLoading(false));
        }
    };

    return (
        <Dialog
            open
            onClose={handleClose}
            aria-labelledby="remove-user-dialog-title"
            aria-describedby="remove-user-dialog-description">
            <Styled.DialogTitle id="remove-user-dialog-title">
                {formatMessage(Locale.bulkUserImportRemoveUserHeader)}
            </Styled.DialogTitle>
            <Styled.Icon aria-label="close" onClick={handleClose}>
                <CloseIcon />
            </Styled.Icon>
            <Styled.DialogContent>{formatMessage(Locale.bulkUserImportRemoveUserContent)}</Styled.DialogContent>
            <Styled.Actions>
                <Button size="medium" variant="outlined" color="secondary" onClick={handleClose}>
                    {formatMessage(Locale.cancel)}
                </Button>
                <Button size="medium" variant="contained" color="dangerPrimary" onClick={handleRemoveUser}>
                    {formatMessage(Locale.removeUser)}
                </Button>
            </Styled.Actions>
        </Dialog>
    );
};

export default RemoveUserDialog;
